


























import { Vue, Component, Prop } from "vue-property-decorator";
import { ICustomStylingClass } from "@/components/Globals/types/custom.t";
import CustomContainer from './Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import baseSpinner from '@/components/Spinner';

@Component({
  components: {
    CustomContainer,
    CustomText,
    baseSpinner
  }
})

export default class UgcUploading extends Vue {
  @Prop()
  customsClass?: ICustomStylingClass[];

  @Prop()
  modalTitle?: string;

  @Prop()
  topSubtitle?: string;

  @Prop()
  bottomSubtitle?: string;

  @Prop({default: '50'})
  spinnerSize!: string | number;
}

